// Canonical shared genesis-only market predicate and helpers.
// Single source of truth for web, mobile, and server serializers.
// See AGENTS.md lessons on never duplicating pure client predicates over public market JSON.

export const GENESIS_MARKET_BADGE_TEXT = "Genesis only";
export const GENESIS_MARKET_ELIGIBILITY_MESSAGE = "This market is for Saga & Seeker Genesis token holders only.";
export const GENESIS_MARKET_BADGE_MESSAGE = "Saga & Seeker Genesis token holders only";
const GENESIS_MARKET_ERROR_MESSAGE = "Vote failed. Please try again.";

function normalizeEligibility(raw) {
  return String(raw || "").trim().toLowerCase();
}

function isGenesisEligibility(raw) {
  return normalizeEligibility(raw) === "genesis";
}

function isGenesisMarketRecord(market = {}) {
  return Boolean(
    market?.requiresGenesisAccess === true ||
      market?.requires_genesis_access === true ||
      market?.accessPolicy === "genesis_only" ||
      isGenesisEligibility(market?.requiredVoteEligibility) ||
      isGenesisEligibility(market?.required_vote_eligibility)
  );
}

export function isGenesisMarket(market = {}) {
  return isGenesisMarketRecord(market);
}

export function genesisMarketBadgeLabel(market = {}) {
  return isGenesisMarket(market) ? GENESIS_MARKET_BADGE_TEXT : "";
}

export function genesisMarketBadgeDescription(market = {}) {
  return isGenesisMarket(market) ? GENESIS_MARKET_BADGE_MESSAGE : "";
}

export function resolveGenesisVoteErrorMessage(error, market = {}) {
  const message = String(error?.message || "").trim();
  if (!isGenesisMarket(market)) {
    return message || GENESIS_MARKET_ERROR_MESSAGE;
  }
  if (message && message !== GENESIS_MARKET_ERROR_MESSAGE) {
    return message;
  }
  return GENESIS_MARKET_ELIGIBILITY_MESSAGE;
}

// Server-side alias (some paths use different naming). Delegates to canonical.
export const marketIsGenesisOnly = isGenesisMarket;
export const marketRequiresGenesisAccess = (record = {}) =>
  isGenesisMarket(record) || Boolean(record?.marketMode === "genesis_only");
